"use client";

import { ModalBody as HeroModalBody } from "@heroui/react";
import { cn } from "../../lib/utils";

export const ModalBody = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroModalBody>) => {
  return <HeroModalBody className={cn(className)} {...props} />;
};
